module.exports = __webpack_public_path__ + "components/t-shirt-comp/static/Hendaye-Plage-21187033b1d1f39d0cd181bdae077e05.jpg";